import {
  QrCodeDetailSection,
  QrCodeHeaderSection
} from 'modules/components';
import { useParams } from 'react-router-dom';



export const QrCodeActivity = () => {
  const {
    entityType,
    entityId,
    projectId
  } = useParams();

  return (
    <>
      <QrCodeHeaderSection.FC />
      <QrCodeDetailSection.FC
        entityType={entityType}
        entityId={entityId}
        projectId={projectId}
      />
    </>
  );
};
